// Naslov, prikazan na kontaktni strani, ki prejema tudi vse oddane obrazce.
export const CONTACT_EMAIL = 'andrej.plibersek@gmail.com';
